'use client';
import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useId } from '../../hooks/use-id.js';
import { useNonNullishFormFieldContext } from './form.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const FormHelper = renderWithRef('FormHelper', null, (o, c)=>{
    var { children: i } = o, s = _object_without_properties(o, [
        "children"
    ]);
    let u = useId(s.id), { setHelperIds: l } = useNonNullishFormFieldContext();
    return useEffect(()=>(u && l((e)=>new Set([
                ...e,
                u
            ])), ()=>{
            u && l((e)=>{
                let r = new Set([
                    ...e
                ]);
                return r.delete(u), r;
            });
        }), [
        u,
        l
    ]), jsx(RenderComp, {
        root: "p",
        forwardedRef: c,
        props: _object_spread_props(_object_spread({}, s), {
            id: u
        }),
        classNames: [
            'swan-input-group-helper-text'
        ],
        children: i
    });
});

export { FormHelper };
